import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { SelectCheckbox } from '../checkbox/checkbox';
import { SelectContext } from '../select-context';

const SelectAllOptions = ({ i18n = { deselect: 'Deselect All', select: 'Select All' } }) => {
  const {
    hasSelectedAllOptions: { selected, indeterminate },
    handleClickSelectAll
  } = useContext(SelectContext);

  return (
    <div className="motif-select-all" onClick={handleClickSelectAll}>
      <SelectCheckbox selected={selected} indeterminate={indeterminate} />
      {selected ? i18n.deselect : i18n.select}
    </div>
  );
};

SelectAllOptions.propTypes = {
  i18n: PropTypes.shape({
    deselect: PropTypes.string,
    select: PropTypes.string
  }).isRequired
};

export { SelectAllOptions };
